<template>
    <el-dialog
        :title="(isForm ? (props.equTypeId ? '编辑' : '添加厂家') : '查看') + dialogTitle"
        :model-value="modelValue"
        width="640px"
        @close="closed"
        class="customForm"
        :close-on-click-modal="false"
    >
        <el-form
            ref="formRef"
            :model="formData"
            :rules="props.equTypeId ? [] : formRules"
            label-width="120px"
            style="max-width: 560px"
        >
            <el-form-item label="厂家名称" prop="name">
                <el-input v-if="isForm" v-model="formData.name" placeholder="厂家名称"></el-input>
                <span v-else>{{ formData.name }}</span>
            </el-form-item>
            <el-form-item label="厂家标识" prop="code">
                <el-input v-if="isForm" v-model="formData.code" placeholder="厂家标识"></el-input>
                <span v-else>{{ formData.code }}</span>
            </el-form-item>

            <el-form-item label="设备类型状态" prop="status">
                <el-radio-group v-if="isForm" v-model="formData.status">
                    <el-radio :value="1">启用</el-radio>
                    <el-radio :value="0">禁用</el-radio>
                </el-radio-group>
                <span v-else>{{ formData.status == 0 ? '禁用' : '启用' }}</span>
            </el-form-item>
            <el-form-item label="显示状态" prop="status">
                <el-radio-group v-if="isForm" v-model="formData.visible">
                    <el-radio :value="1">显示</el-radio>
                    <el-radio :value="0">隐藏</el-radio>
                </el-radio-group>
                <span v-else>{{ formData.visible == 0 ? '隐藏' : '显示' }}</span>
            </el-form-item>
            <el-form-item label="排序值">
                <el-input-number
                    v-if="isForm"
                    v-model="formData.list_order"
                    class="mx-4"
                    :min="0"
                    :max="999999"
                    controls-position="right"
                />
                <span v-else>{{ formData.list_order }}</span>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script setup>
import { defineEmits, defineProps, nextTick, ref, watch } from 'vue'
import { addManufacturerType, getManufacturerDetail, putManufacturerType } from '@/api/deviceBrand/deviceBrandFactory'
import { ElMessage } from 'element-plus'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    equTypeId: {
        type: String,
        required: false
    }
})

const emits = defineEmits(['update:modelValue', 'updateForm'])
const submitLoading = ref(false)
const formData = ref({
    code: '',
    name: '',
    status: 1,
    visible: 1,
    list_order: 1
})
const dialogTitle = ref('')

// 设备类型非中文验证
const validatePass = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请输入设备类型标识'))
    } else if (!/^[^[\u4e00-\u9fa5]{1,50}]*$/.test(value)) {
        callback(new Error('设备类型标识不可含有中文'))
    } else {
        callback()
    }
}

// 验证规则
const formRules = ref({
    id: [
        {
            required: true,
            trigger: 'blur',
            message: '设备类型标识为必填项'
        }
    ],
    name: [
        {
            required: true,
            trigger: 'blur',
            message: '设备类型名称为必填项'
        }
    ],
    code: [
        {
            required: true,
            trigger: 'blur',
            validator: validatePass
        }
    ]
})

// 提交
const formRef = ref(null)
const onConfirm = () => {
    formRef.value.validate(async (valid) => {
        try {
            if (valid) {
                submitLoading.value = true
                if (!props.isForm) return
                if (props.equTypeId !== '') {
                    await doPutModule(formData.value)
                } else {
                    await doAddModule(formData.value)
                }
            }
        } catch (error) {
            submitLoading.value = false
        }
    })
}

// 编辑
const doPutModule = async (data) => {
    try {
        await putManufacturerType(data)
        emits('updateForm')
        ElMessage.success('修改成功！')
        submitLoading.value = false
        closed()
    } catch (error) {
        submitLoading.value = false
    }
}

// 添加
const doAddModule = async (data) => {
    try {
        await addManufacturerType(data)
        emits('updateForm')
        ElMessage.success('添加成功！')
        submitLoading.value = false
        closed()
    } catch {
        submitLoading.value = false
    }
}

const closed = () => {
    formRef.value.resetFields()
    formData.value.code = ''
    formData.value.note = ''
    dialogTitle.value = ''
    emits('update:modelValue', false)
}

// 详情
const getEquipDetailFun = async () => {
    const data = await getManufacturerDetail(props.equTypeId)
    nextTick(() => {
        formData.value = data
        dialogTitle.value = formData.value.name
    })
}

watch(
    () => props.equTypeId,
    (newVal) => {
        if (newVal) {
            getEquipDetailFun()
        } else {
            formRef.value.resetFields()
            formData.value.note = ''
        }
    }
)
</script>

<style lang="scss">
.customForm :deep(.el-dialog__body) {
    height: 40vh !important;
    overflow: auto;
}
</style>
